import React, { createContext, useContext, useMemo, useState } from 'react';

interface ReviewBudgetDrawTabContextType {
  activeDrawId: string | null;
  setActiveDrawId: (drawId: string | null) => void;
}

const ReviewBudgetDrawTabContext = createContext<ReviewBudgetDrawTabContextType | undefined>(undefined);

/**
 * Lets the wizard stepper (which sits above the step content) select which draw's tab the
 * Review Budget step shows, so clicking a draw-scoped substep can mount that draw's panel before
 * scrolling to its anchor. Optional: without the provider the step falls back to its own tab state.
 */
export const ReviewBudgetDrawTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeDrawId, setActiveDrawId] = useState<string | null>(null);
  const value = useMemo(() => ({ activeDrawId, setActiveDrawId }), [activeDrawId]);
  return <ReviewBudgetDrawTabContext.Provider value={value}>{children}</ReviewBudgetDrawTabContext.Provider>;
};

export const useReviewBudgetDrawTab = () => useContext(ReviewBudgetDrawTabContext);
